<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <h1 class="text-center">FAQ</h1>
        <v-row justify="center">
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>Pertanyaan 1</v-expansion-panel-header>
              <v-expansion-panel-content>
                Deskripsi jawaban untuk pertanyaan 1...
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Pertanyaan 2</v-expansion-panel-header>
              <v-expansion-panel-content>
                Deskripsi jawaban untuk pertanyaan 2...
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Help',
  data: () => ({
    word: 'Vue',
  }),
  created: () => ({
  }),
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
